import { Lightbulb, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RecommendationsCardProps {
  recommendations: string[];
  className?: string;
}

export function RecommendationsCard({ recommendations, className }: RecommendationsCardProps) {
  if (recommendations.length === 0) {
    return null;
  }

  return (
    <div className={cn('rounded-2xl border bg-card p-4 sm:p-6', className)}>
      <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
        <div className="rounded-lg bg-warning/10 p-1.5 sm:p-2">
          <Lightbulb className="h-4 w-4 sm:h-5 sm:w-5 text-warning" />
        </div>
        <h3 className="text-base sm:text-lg font-semibold">Recomendaciones del mes</h3>
      </div>
      
      <div className="space-y-3 sm:space-y-4">
        {recommendations.map((recommendation, index) => (
          <div 
            key={index}
            className="flex gap-2 sm:gap-3 animate-slide-up"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            <ChevronRight className="h-4 w-4 sm:h-5 sm:w-5 text-primary mt-0.5 flex-shrink-0" />
            <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
              {recommendation}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
